import { createSlice, current } from '@reduxjs/toolkit'
import { tabs } from 'pages/banners/components/constants'

const initialState = {
  pages: {
    loading: false,
    data: [],
    error: '',
    init: false,
    selectedPage: '',
    processing: false,
  },
  banners: {
    loading: false,
    data: [],
    error: '',
    init: false,
    selectedBannerType: '',
    allBannersCount: 0,
    activeBannersCount: 0,
    inActiveBannersCount: 0,
    activeTab: tabs[0],
    processing: false,
    allBanners: [],
    toggle:false,
    hasNext:true,
    hasPrev: false,
    page: 0,
  },
  flashSale: {
    loading: false,
    error: '',
    data: null,
  },
}

const bannerSlice = createSlice({
  name: 'bannerSlices',
  initialState: initialState,
  reducers: {
    fetchPages: () => {},
    fetchBanners: (state) => {},
    removeBanner: () => {},
    rearrangeBanners: () => {},
    toggleBannerStatus: () => {},
    tryCreateBanner: () => {},
    tryCreateBannerType: () => {},
    tryUpdateBanner: () => {},
    tryDeleteBannerType: () => {},
    tryUpdateBannerType: () => {},
    setPages: (state, action) => {
      const { data, error = '' } = action.payload
      state.pages.error = error
      state.pages.loading = false
      if (!error) {
        state.pages.data = data
        state.pages.init = true
      }
    },
    setLoading: (state, action) => {
      state[action.payload.element].error = ''
      state[action.payload.element].loading = action.payload.loading
    },
    setSelectedPage: (state, action) => {
      state.banners.page = 0;
      state.pages.selectedPage = action.payload.page
    },
    setSelectedTab: (state, action) => {
      state.banners.activeTab = action.payload
    },
    filterBanners: (state, action) => {
      const { screen, tab } = action.payload

      segregateBannersByScreenAndTab(state, screen, tab)

      state.banners.loading = false
    },
    setBanners: (state, action) => {
      const { screen, tab, response:{page, has_next, has_prev, data} } = action.payload
      state.banners.data = data;
      state.banners.page = page;
      state.banners.hasNext = has_next;
      state.banners.hasPrev = has_prev;
      state.banners.init = true

      state.banners.loading = false
      state.banners.toggle = !state.banners.toggle;

      segregateBannersByScreenAndTab(state, screen, tab)
    },
    deleteBanner: (state, action) => {
      const { bannerId, screen, tab } = action.payload
      state.banners.data = state.banners.data.filter(
        (banner) => banner.id !== bannerId,
      )
      state.banners.processing = false
      segregateBannersByScreenAndTab(state, screen, tab)
    },
    setBannerProcessing: (state, action) => {
      state.banners.processing = action.payload
    },
    setBannerPageProcessing: (state, action) => {
      state.pages.processing = action.payload
    },
    setRearrangedBanners: (state, action) => {
      const { banners, screen, tab } = action.payload
      state.banners.data = banners
      segregateBannersByScreenAndTab(state, screen, tab)
    },
    modifyStatus: (state, action) => {
      const { banner, screen, tab } = action.payload

      const targetIndex = state.banners.data.findIndex(
        (b) => b.id === banner.id,
      )

      state.banners.data[targetIndex] = banner

      segregateBannersByScreenAndTab(state, screen, tab)
    },
    setNewBanner: (state, action) => {
      const { newBanner, screen, tab, canPush } = action.payload
      if (canPush) {
        state.banners.data.push(newBanner)
        segregateBannersByScreenAndTab(state, screen, tab)
        state.banners.processing = false
      }
      state.banners.toggle =  !state.banners.toggle;
    },
    setUpdatedBanner: (state, action) => {
      const { bannerId, screen, tab, data } = action.payload
      const targetIndex = state.banners.data.findIndex((b) => b.id === bannerId)
      state.banners.data[targetIndex] = data
      state.banners.toggle = !state.banners.toggle;
      segregateBannersByScreenAndTab(state, screen, tab)
    },
    tryGetActiveFlashSale:() => {},
    setFlashSale: (state, action) => {
      const {loading, error, flashSale} = action.payload
      state.flashSale.loading = loading
      state.flashSale.error = error
      if (flashSale !== null) {
        state.flashSale.data = flashSale
      }
    },
    setError: (state, action) => {
      state[action.payload.element].error = action.payload.error
      state[action.payload.element].loading = false 
    },
  },
})

// TODO remove later
// const getBannersByScreen = (banners, screen) => {
//   return banners.filter((banner) => banner.screen === screen)
// }

const getActiveBanners = (banners) => {
  return banners.filter((b) => b?.active_banner !== undefined)
}

const getInActiveBanners = (banners) => {
  return banners.filter((b) => b?.active_banner === undefined)
}

const segregateBannersByScreenAndTab = (state, screen, tab) => {
  const allBannersByScreen = state.banners.data
  const activeBanners = getActiveBanners(allBannersByScreen)
  const inActiveBanners = getInActiveBanners(allBannersByScreen)

  state.banners.allBannersCount = allBannersByScreen.length
  state.banners.activeBannersCount = activeBanners.length
  state.banners.inActiveBannersCount = inActiveBanners.length

  switch (tab) {
    case tabs[0].value:
      state.banners.allBanners = allBannersByScreen
      break
    case tabs[1].value:
      state.banners.allBanners = activeBanners
      break
    case tabs[2].value:
      state.banners.allBanners = inActiveBanners
      break
    default:
      state.banners.allBanners = allBannersByScreen
  }
}

export const {
  fetchPages,
  fetchBanners,
  setBanners,
  setPages,
  setLoading,
  setSelectedPage,
  setSelectedTab,
  removeBanner,
  setBannerProcessing,
  rearrangeBanners,
  setRearrangedBanners,
  toggleBannerStatus,
  modifyStatus,
  filterBanners,
  tryCreateBannerType,
  setBannerPageProcessing,
  tryCreateBanner,
  setNewBanner,
  tryUpdateBanner,
  setUpdatedBanner,
  deleteBanner,
  tryDeleteBannerType,
  tryGetActiveFlashSale,
  setFlashSale,
  setError,
  tryUpdateBannerType
} = bannerSlice.actions

export default bannerSlice.reducer